import gettext from '@eb/gettext';
import { formatNumber, unformat } from '@eb/intl';
import {
    FIELDS_TO_VALIDATE,
    MAX_TICKET_QUANTITY,
    MIN_TICKET_QUANTITY,
    MAX_TICKET_PRICE,
} from './constants';

export const getMaxPriceErrorMessage = (maxPrice) =>
    gettext('Price must be less than %(maxPrice)s', { maxPrice });
export const getQuantityErrorMessage = (range) =>
    gettext('Quantity must be between %(min)s and %(max)s.', range);

const _maxValue = (max, message) => (val) => val > max && message;

const _minValue = (min, message) => (val) => val < min && message;

const _ticketPriceMaxPriceValidator = (max, message, state) => (val) => {
    const unformattedPrice = unformat(val, state.currencyFormat);

    return _maxValue(max, message)(unformattedPrice);
};

const _getTicKetPriceErrorMessage = (state) => {
    const currencySymbol = state.currencySymbol;
    const currencyFormat = state.currencyFormat;
    const sanitizedMax = formatNumber(
        unformat(MAX_TICKET_PRICE, currencyFormat),
        currencyFormat,
        { precision: 0 },
    );

    return getMaxPriceErrorMessage(`${currencySymbol}${sanitizedMax}`);
};

const _getValidations = (state) => {
    const ERROR_MESSAGE_WITH_FORMATTED_PRICE = _getTicKetPriceErrorMessage(
        state,
    );
    const ERROR_MESSAGE_QUANTITY_WITH_RANGE = getQuantityErrorMessage({
        max: MAX_TICKET_QUANTITY,
        min: MIN_TICKET_QUANTITY,
    });

    return {
        ticketPrice: [
            _ticketPriceMaxPriceValidator(
                MAX_TICKET_PRICE,
                ERROR_MESSAGE_WITH_FORMATTED_PRICE,
                state,
            ),
        ],
        ticketQuantity: [
            _maxValue(MAX_TICKET_QUANTITY, ERROR_MESSAGE_QUANTITY_WITH_RANGE),
            _minValue(MIN_TICKET_QUANTITY, ERROR_MESSAGE_QUANTITY_WITH_RANGE),
        ],
    };
};

export const validate = (state) => {
    const errorMessages = FIELDS_TO_VALIDATE.reduce((acc, fieldKey) => {
        const errorsForField = _getValidations(state)[
            fieldKey
        ].map((validator) => validator(state[fieldKey]));
        const newErrorMessage = { ...acc };

        newErrorMessage[`${fieldKey}Error`] = errorsForField[0];
        return newErrorMessage;
    }, {});

    return {
        valid: Object.values(errorMessages).filter(Boolean).length === 0,
        errorMessages,
    };
};
